import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './styles/theme';
import Header from './components/Header';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import Admin from './pages/Admin';
import AdminCosts from './pages/AdminCosts';
import Costos from './pages/Costos';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/costos" element={<Costos />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/costos" element={<AdminCosts />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
